import { useEffect } from "react";

import { HStack, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../store/store_context";

import FiltersGrid from "../components/profit_page/filters_grid";
import ProfitTable from "../components/profit_page/table_profit";
import LoaderIndicator from "../components/loader_indicator";

const ProfitPage = observer(() => {
  const { pageStore } = useStores();
  useEffect(() => {
    pageStore.getAllPromos();
    pageStore.getAllPeriods();
    pageStore.getAllBackups();
    pageStore.resetFilters();
  }, []);

  return (
    <VStack width={"100%"} align={"flex-start"}>
      <HStack
        width="100%"
        spacing="15px"
        wrap="wrap"
        padding="0 20px"
        marginTop="20px"
        justify="center"
      >
        <FiltersGrid renderButtons={(buttons) => buttons} />
        <ProfitTable data={pageStore.data_profit} renderButtons={(buttons) => buttons} />
      </HStack>
    </VStack>
  );
});

export default ProfitPage;
